// extracted by mini-css-extract-plugin
export var cardIcon = "_7x-5";
export var cardIconUnframed = "_7x-9";
export var checkboxCard = "_7x-0";
export var checkboxCardSelected = "_7x-4";
export var disabled = "_7x-2";
export var interactive = "_7x-1";
export var outerBorder = "_7x-3";
export var spacerMedium = "_7x-8";
export var spacerSmall = "_7x-7";
export var spacerXsmall = "_7x-6";